import { Dispatch, Action } from 'redux'
import { AppUpdatedMainMapDispatchReturnType } from './types/AppUpdatedMainMapDispatchReturnType'

export const AppUpdatedMainMapDispatch = (
  _dispatch: Dispatch<Action>
): AppUpdatedMainMapDispatchReturnType => {
  return {
  }
}
